import { useEffect, useState } from 'react'

/*
Despliega un par label: valor
*/
interface DisplayValueProps {
  label?: string
  value?: string | number | null
  className?: string // Add className as an optional prop
  valueClass?: string
  errors?: { [key: string]: string }
  name?: string
}

export const DisplayValue: React.FC<DisplayValueProps> = ({ label, value, className }) => {
  const myLabel = label ? `${label}:` : ''

  return (
    <div className={`whitespace-nowrap ${className ?? 'col-span-1'}`}>
      <span className="font-bold">{myLabel}</span> {value ?? ''}
    </div>
  )
}
export const DisplayValueEx: React.FC<DisplayValueProps> = ({ label, value, className, valueClass }) => {
  return (
    <>
      <div className={className}>{label ?? ''}</div>
      <div className={valueClass}> {value ?? ''}</div>
    </>
  )
}
export const DisplayValueFormat: React.FC<DisplayValueProps> = ({ label, value, className }) => {
  return (
    <>
      <div className={className}>{label ?? ''}</div>
      <div className="font-bold"> {value ?? ''}</div>
    </>
  )
}
export const DisplayValueFormatNoPrint: React.FC<DisplayValueProps> = ({ label, value, className }) => {
  return (
    <>
      <div className={`${className} print:hidden`}>{label ?? ''}</div>
      <div className="font-bold print:hidden"> {value ?? ''}</div>
    </>
  )
}
export const DisplayValueCol: React.FC<DisplayValueProps> = ({ label, value }) => {
  return (
    <div className="grid grid-cols-2 whitespace-nowrap">
      <div className="font-bold">{label}</div>
      <div>{value}</div>
    </div>
  )
}
/*
Despliega el label 
*/
export const DisplayLabel: React.FC<DisplayValueProps> = ({ label, className }) => {
  return (
    <div className={`whitespace-nowrap ${className ?? 'col-span-1'}`}>
      <span className="font-bold">{label}</span>
    </div>
  )
}

/*
Despliega un valor label Value, con el label arriba
*/
export const DisplayValueVert: React.FC<DisplayValueProps> = ({
  label,
  value,
  className,
  valueClass,
  errors,
  name,
}) => {
  const myClassName = className ?? 'flex flex-col'
  const [inputClass, setInputClass] = useState<string>('')
  const inputClassDef = 'border rounded p-2'
  useEffect(() => {
    const hayError = errors && name && errors[name]
    const borderColor = hayError ? 'ring-4 ring-red-500' : ''
    setInputClass(`${inputClassDef} ${borderColor}`)
  }, [errors, name])

  return (
    <div className={myClassName}>
      <label className="font-semibold mb-1">{label}</label>
      <label className={`${inputClass}  ${valueClass}`}>{value}</label>
    </div>
  )
}
/*
Despliega un valor label Value, con un indicador de error
*/
export const DisplayValueWithError: React.FC<DisplayValueProps> = ({ value, valueClass, errors, name }) => {
  const [inputClass, setInputClass] = useState<string>('')

  useEffect(() => {
    const hayError = errors && name && errors[name]
    const borderColor = hayError ? 'ring-4 ring-red-500' : ''
    setInputClass(`${borderColor}`)
  }, [errors, name])

  return <label className={`${inputClass}  ${valueClass}`}>{value}</label>
}
